module.exports = {
  apiHost: "https://api.newenham.sensoreal.app",
  assetsHost: "https://assets.newenham.sensoreal.app",
  contact: {
    address: "164 Flaxley Road, Mount Barker SA 5251",
    email: "sales@newenham.com.au",
    phone: "0429 107 497",
    website: "https://newenham.com.au",
  },
  formTemplate: "default",
  header: {
    logo: "https://newenham.netlify.app/assets/newenham-logo.svg",
    text: {
      en: "Your Newenham Selections",
      ar: "",
    },
    color: "#fff",
  },
  langs: [{ code: "en", dir: "ltr" }],
  links: {
    instagram: "https://www.instagram.com/newenhamadelaidehills/",
    facebook: "https://www.facebook.com/NewenhamAdelaideHills/",
    linkedin: "",
    privacy: "https://newenham.com.au/privacy-policy",
    twitter: "",
    youtube: "",
  },
  style: {
    primaryColor: "#414042",
    textColor: "#fff",
  },
};
